import ImagesPressLogosWhiteSpiritoryJpg from '@/public/images/press/logos/white/spiritory.jpg';
import ImagesPressLogosWhiteSpiritoryLogoJpg from '@/public/images/press/logos/white/spiritoryLogo.jpg';
import ImagesPressLogosWhiteSpiritoryLogoPng from '@/public/images/press/logos/white/spiritoryLogo.png';
import ImagesPressLogosWhiteSpiritoryLogoSvg from '@/public/images/press/logos/white/spiritoryLogo.svg';
import ImagesPressLogosWhiteSpiritoryPng from '@/public/images/press/logos/white/spiritory.png';
import ImagesPressLogosWhiteSpiritorySvg from '@/public/images/press/logos/white/spiritory.svg';

export {
  ImagesPressLogosWhiteSpiritoryJpg,
  ImagesPressLogosWhiteSpiritoryLogoJpg,
  ImagesPressLogosWhiteSpiritoryLogoPng,
  ImagesPressLogosWhiteSpiritoryLogoSvg,
  ImagesPressLogosWhiteSpiritoryPng,
  ImagesPressLogosWhiteSpiritorySvg,
};
